import React, { useState, useEffect } from "react";
// import styles from "./footer.module.css";
import heart from "../../assets/icons/Heart.svg";
import fb from "../../assets/icons/facebook.svg";
import insta from "../../assets/icons/instagram.svg";
import twitter from "../../assets/icons/twitter.svg";
import { useNavigate } from "react-router-dom";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { OptimizedImage } from "../../utils/imageOptimizer";

const Footer = () => {
  const { t, i18n } = useTranslation();
  const [currentLang, setCurrentLang] = useState(i18n.language);
  const navigate = useNavigate();

  // Update currentLang when i18n language changes
  useEffect(() => {
    const handleLanguageChange = () => {
      setCurrentLang(i18n.language);
    };

    // Set initial language
    setCurrentLang(i18n.language);

    // Listen for language changes
    i18n.on('languageChanged', handleLanguageChange);

    return () => {
      i18n.off('languageChanged', handleLanguageChange);
    };
  }, [i18n]);

  return (
    <div className="max-w-[1440px] w-[95%] mx-auto">
      <div className="px-4 w-full mx-auto box-border text-center mt-8 md:px-10 md:mt-16">
        <div className="w-full flex justify-center mt-0">
          <OptimizedImage
            src="Images/logo-new.png"
            style={{ cursor: "pointer" }}
            onClick={() => navigate("/index")}
            alt="Logo"
            className="w-28 md:w-20"
          />
        </div>
        <div className="mt-4 mb-4 flex justify-center items-center ">
          <span className="text-base font-bold font-inter text-[#333] -ml-2">
            {t("footer.made_with")}
          </span>
          <img src={heart} alt="Heart" className="h-auto w-5 mx-4" loading="lazy" />
          <span className="text-base font-bold text-[#333] font-inter text-left">{t("footer.in_munich")}</span>
        </div>
        <div className="flex justify-center items-center m-auto gap-2">
          <a href="https://www.instagram.com/netmeapp/" className="p-0">
            <img src={insta} alt="Instagram" loading="lazy" />
          </a>
          <a href="https://twitter.com/netmeapp" className="p-0">
            <img src={twitter} alt="Twitter" loading="lazy" />
          </a>
          <a href="https://www.facebook.com/netmeapp" className="p-0">
            <img src={fb} alt="Facebook" loading="lazy" />
          </a>
        </div>
      </div>
      <div className="w-full mx-auto mt-3 text-center flex flex-row flex-wrap justify-center gap-4 md:gap-5 md:w-[95%] md:mt-4 md:mb-10">
        {/* <Link to="/">
          <span className={styles.menu}>{t("footer.menu.app")}</span>
        </Link> */}
        <Link to="/faq">
          <span className="text-base font-inter font-bold text-[#333] md:min-w-0 md:pl-0">{t("footer.menu.faq")}</span>
        </Link>
        <Link to="/about">
          <span className="text-base font-inter font-bold text-[#333] md:min-w-0 md:pl-0">{t("footer.menu.about")}</span>
        </Link>
        <Link to="/becomeapartner">
          <span className="text-base font-inter font-bold text-[#333] md:min-w-0 md:pl-0">{t("footer.menu.become_partner")}</span>
        </Link>
        <Link to="/register">
          <span className="text-base font-inter font-bold text-[#333] md:min-w-0 md:pl-0">{t("footer.menu.ads")}</span>
        </Link>
        <Link to="/terms-conditions">
          <span className="text-base font-inter font-bold text-[#333] md:min-w-0 md:pl-0">
            {t("footer.menu.terms_conditions")}
          </span>
        </Link>
        <Link to="/privacy-policy">
          <span className="text-base font-inter font-bold text-[#333] md:min-w-0 md:pl-0">{t("footer.menu.privacy_policy")}</span>
        </Link>
        <Link to="/legal-disclosure">
          <span className="text-base font-inter font-bold text-[#333] md:min-w-0 md:pl-0">
            {t("footer.menu.legal_disclosure")}
          </span>
        </Link>
      </div>
      <p className="text-center text-[#333] text-xs font-inter font-bold my-5">{t("footer.copyright")}</p>
    </div>
  );
};

export default Footer;
